// extracted by mini-css-extract-plugin
module.exports = {"Background":"Result_Background__2zwzc","Main":"Result_Main__1BFBC","Select":"Result_Select__fpWc7","Item":"Result_Item__3eHAZ","id":"Result_id__3D7cJ"};